const formMoveToLand = () => {
  const btns = document.querySelectorAll('.grades__item')
  const submit = document.querySelector('.grades__submit')
  const error = document.querySelector('.grades__error')

  let url = ''
  let grade = ''
  let landUrl = ''

  let params = new URLSearchParams(window.location.search).toString()
  params = params.length > 0 ? '&' + params : ''

  if (btns) {
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(otherBtns => {
          if (otherBtns !== btn) {
            otherBtns.classList.remove('selected')
          }
        })
        btn.classList.add('selected')
        grade = btn.getAttribute('data-value')
      })
    })
  }

  if (submit) {
    submit.addEventListener('click', () => {
      if (grade) {
        landUrl = submit.getAttribute('data-url')
        url = (grade && landUrl) ? `${landUrl}?grade=${grade}` + params : window.location.href
        window.location.href = url
        error.classList.remove('error')
      } else {
        error.classList.add('error')
      }
    })
  }
}

export default formMoveToLand
